import React from 'react'
import { RasaBrowserComponent } from 'generic/rasaBrowserComponent'
import { RasaContext } from 'context'
import { AnalyticsInsightsChat } from './analytics-insights-chat'
import * as Flash from '../flash'
import { HeaderComponent } from 'components/header/component'
import { Loading, SIZES } from 'components/loading'
import './analytics-insights.scss'

interface AnalyticsInsightsProps {
  [key: string]: any
}

interface AnalyticsInsightsState {
  communityId: string
  isLoading: boolean
}

export class AnalyticsInsightsComponent extends RasaBrowserComponent<
  AnalyticsInsightsProps,
  AnalyticsInsightsState
> {
  public static contextType = RasaContext

  constructor(props: AnalyticsInsightsProps) {
    super(props, {
      communityId: '',
      isLoading: true
    })
  }

  componentDidMount() {
    this.context.user.init().then(({ activeCommunity }) => {
      this.setState({
        communityId: activeCommunity.communityId,
        isLoading: false
      })
    }).catch((error) => {
      this.setState({ isLoading: false })
      this.context.store.dispatch(Flash.showFlashError(error))
    })
  }

  private handleError = (error: string) => {
    this.context.store.dispatch(Flash.showFlashError(error))
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <Loading size={SIZES.MEDIUM} />
          <p style={{ marginTop: '16px', color: '#718096' }}>Loading Analytics Insights Assistant...</p>
        </div>
      )
    }

    return (
      <div>
        <HeaderComponent
          title="Ask Scout"
          subTitle="Ask questions about your analytics data and get instant insights"
        />
        <div className="analytics-insights-wrapper">
          <AnalyticsInsightsChat
            communityId={this.state.communityId}
            onError={this.handleError}
          />
        </div>
      </div>
    )
  }
}
